<template>
  <!-- A vertical list of radio options, for choices with long labels -->
  <div
    role="radiogroup"
    class="kb-radio-list"
    :aria-labelledby="ariaLabelledby"
  >
    <label
      v-for="(option, index) in options"
      :key="String(option.value)"
      class="kb-radio-option"
      :class="{ 'is-disabled': disabled || option.disabled }"
      :for="`${name}-${index}`"
    >
      <RadioButton
        v-model="model"
        :input-id="`${name}-${index}`"
        :name="name"
        :value="option.value"
        :disabled="disabled || option.disabled"
        :invalid="invalid"
        size="small"
        @change="$emit('change', option.value)"
      />
      <span>
        {{ option.label }}
        <small
          v-if="option.hint"
          class="kb-field-hint block"
        >{{ option.hint }}</small>
      </span>
    </label>
  </div>
</template>

<script setup lang="ts" generic="T extends string | number | boolean">
export interface KbRadioOption<V> {
  label: string
  value: V
  hint?: string
  disabled?: boolean
}

defineProps<{
  name: string
  options: KbRadioOption<T>[]
  disabled?: boolean
  invalid?: boolean
  ariaLabelledby?: string
}>()

defineEmits<{ change: [value: T] }>()

const model = defineModel<T | null | undefined>()
</script>
